// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 358) return "static/chunks/358-535595cd0d4a4694.js";
	if (chunkId === 521) return "static/chunks/521-1a32a4020cd8a5a0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"3a352900d2c5129b","205":"142f13705c668700","319":"eb0d8af2008f705f","340":"486a3ab8639da320","367":"55e1e62d96da3dc1","639":"a322f5d778fbd249","748":"7db5daca9e061c15"}[chunkId] + ".js";
};